export default "__VITE_ASSET__CT7OOb3___"